import { Navigate } from "react-router";
import { useGetPricingProfileQuery } from "../../../apis/PricingProfile.api";
import { PrimaryPricingProfile, PricingProfile } from "../../../types/models/PricingProfile";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const PricingProfileScoped = () => {
    const {
        data,
    } = useGetPricingProfileQuery(PrimaryPricingProfile.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/pricing-profiles/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default PricingProfileScoped;
